import { api } from "@/lib/api";

// Chiave di idempotenza per un singolo salvataggio: riusata nei tentativi, rinnovata dopo il successo.
export const newKey = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

// Nessuna risposta dal server (rete assente, interruzione, timeout): l'esito è sconosciuto.
export const isNetworkError = (e) => !!e && !e.response;

export const idemHeaders = (key) => ({ headers: { "Idempotency-Key": key } });

// "completed" | "pending" | "unknown" | "deleted" (+ resource_id)
export async function checkSaved(key) {
  const { data } = await api.get(`/idempotency/${encodeURIComponent(key)}`);
  return data;
}

const DRAFT_PREFIX = "csp_draft_";
export const saveDraft = (name, value) => { try { sessionStorage.setItem(DRAFT_PREFIX + name, JSON.stringify(value)); } catch (_) {} };
export const loadDraft = (name) => { try { return JSON.parse(sessionStorage.getItem(DRAFT_PREFIX + name) || "null"); } catch (_) { return null; } };
export const clearDraft = (name) => { try { sessionStorage.removeItem(DRAFT_PREFIX + name); } catch (_) {} };
export const clearAllDrafts = () => {
  try { Object.keys(sessionStorage).filter((k) => k.startsWith(DRAFT_PREFIX)).forEach((k) => sessionStorage.removeItem(k)); } catch (_) {}
};
